module.exports = __webpack_public_path__ + "212ed2a57a9492cf43375411e50f056c.svg";